import React from 'react';
import { Button } from '@zurich-primitives/button';
import { Chip } from 'app/components';
import {
  getBootstrapApp,
  getBusinessArea,
  getService,
  useAppSelector
} from 'app/redux';
import { Link } from '@zurich-data-dsm-icons/action.link';
import { useNavigate } from 'react-router-dom';
import styles from './ServiceOptions.module.scss';
import config from 'config';
import { getBusinessAreaKey } from 'app/utils';

export const ServiceOptions: React.FC<{
  showUseOurApiVersion?: boolean;
  styleOptions?: React.CSSProperties;
  selectedBA?: string;
  selectedService?: string;
}> = ({
  showUseOurApiVersion = true,
  selectedBA = undefined,
  selectedService = undefined,
  styleOptions = undefined
}) => {
  const navigate = useNavigate();
  const bootstrap = useAppSelector(getBootstrapApp);
  const services = bootstrap.services;
  const businessAreas = bootstrap.businessAreas;

  const currentService = useAppSelector(getService);

  const businessArea =
    useAppSelector(getBusinessArea) ??
    (currentService
      ? getBusinessAreaKey(businessAreas, currentService)
      : selectedBA);

  const service = useAppSelector(getService) ?? selectedService;

  const handleOpenAPI = (): void => {
    currentService !== undefined &&
      navigate(config.APP.PATH.API?.replace(':api', currentService));
  };

  return (
    <div className={styles['service-options']} style={styleOptions}>
      <div className={styles['selected-areas']}>
        <h3>Selected areas</h3>

        <div className={styles.areas}>
          <div className={styles.chips}>
            {businessArea !== undefined && (
              <Chip
                value={businessAreas[businessArea]?.name}
                id={businessArea}
                icon="Edit"
                selected
                className={styles['chip-area']}
              />
            )}
            {service !== undefined && (
              <Chip
                value={services[service].name}
                id={service}
                icon="Package"
                selected
                className={styles['chip-service']}
              />
            )}
          </div>
        </div>
      </div>
      {showUseOurApiVersion && (
        <Button
          onClick={handleOpenAPI}
          variant="tertiary"
          className={styles['api-button']}
        >
          <Button.Icon>
            <Link />
          </Button.Icon>
          <Button.Label>Use our API version</Button.Label>
        </Button>
      )}
    </div>
  );
};
